/*
 * Purpose: SSOT — live documentation is the control plane for Mission AI agency
 * Last modified: 2026-06-28 | Agent
 * Completeness: 100
 */

export const MISSION_LIVE_DOCUMENTATION_RULE = `As long as every AI action is live-documented — mission dossier, mission task receipts, mission map trail, and mission DB retention — open-ended exploration is acceptable. Execution of elevated/critical effects still requires human approval.`;

/** What must be updated on every AI/system action during a Mission. */
export const MISSION_LIVE_DOCUMENTATION_CHANNELS = [
  'mission_dossier',
  'mission_task_receipt',
  'mission_map_trail',
  'mission_db_retention',
  'user_notification',
] as const;

export type MissionLiveDocumentationChannel = (typeof MISSION_LIVE_DOCUMENTATION_CHANNELS)[number];

/** Open-ended agency is allowed when all channels are satisfied. */
export const MISSION_OPEN_ENDED_WHEN_DOCUMENTED = true;
